

import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";

export default function CheckoutFinishedView({
  goToAppleStore,
  goToPlayStore,
  goBack,
  goToTickets,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="flex items-center w-full flex-col">
            <img 
              src={process.env.PUBLIC_URL +"/icon-checked.png"}
              width={80}
              height={80}
              alt="ícone sucesso"
              className="mt-6"
            />
            <h2 className="text-3xl text-black mt-2">Parabéns!</h2>
            <h3 className="text-base center">Seu pagamento foi realizado com sucesso.</h3>
            <button onClick={goToTickets} type="button" className="w-full h-[calc(60px)] rounded-lg border border-black text-black font-medium mt-10 mb-10">Baixar comprovante</button>
            <div className="mt-6 w-full text-center rounded-lg bg-white p-4">
              <p className="text-xl text-black font-bold">Baixe agora o app</p>
              <p className="mt-2 text-sm	text-black">Acompanhe e pague seus débitos automaticamente pelo celular.</p>
              <div className="mt-4 flex w-full justify-between">
                <button 
                  className="w-5/12	max-w-[calc(216px)] rounded-lg bg-black p-3 text-white flex text-start items-center justify-center"
                  onClick={goToAppleStore}>
                  <img
                    src={process.env.PUBLIC_URL +"/icon-apple.png"}
                    width={36}
                    height={36}
                    alt="ícone apple"
                  />
                  <span className="text-xs ml-2">
                    Disponível na<br/><span className="text-xl font-bold">App Store</span>
                  </span>
                </button>
                <button 
                  className="w-5/12	max-w-[calc(216px)] rounded-lg bg-black p-3 text-white flex text-start items-center justify-center"
                  onClick={goToPlayStore}>
                  <img
                    src={process.env.PUBLIC_URL +"/icon-googleplay.png"}
                    width={24}
                    height={24}
                    alt="ícone google play"
                  />
                  <span className="text-xs ml-2">
                    Disponível na<br/><span className="text-xl font-bold">Google Play</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </article>
      </main>
    </div>
  );
}
